<div class="edit-data edit-data__text" [class.edit-data__text-hidden]="dataType=='text-hidden'" *ngIf="dataType == 'text' || dataType == 'text-hidden'">
  <div *ngIf="!loading" [@fadeIn]>
    <input [id]="inputId" #textInput *ngIf="canEdit" type="text" [ngModel]="value" (ngModelChange) = "onValueChanged($event)"  (focus)="onFocus()" (focusout)="onFocusOut()" />
    <span *ngIf="!canEdit">{{value}}</span>
    <div class="save-button" (click)="saveChange()" *ngIf="showSaveButton" [class.save-button__unsaved]="unsavedData" [class.saving]="saving" matTooltip="Save Changes">
      <i class="material-icons save-button__icon">check</i>
    </div>
    <div class="cancel-button" (click)="cancel()" *ngIf="showCancelButton" matTooltip="Cancel">
      <i class="material-icons cancel-button__icon">close</i>
    </div>
  </div>
  <div class="ph-item" *ngIf="loading">
    <div class="ph-row">
      <div class="ph-col-12 big"></div>
    </div>
  </div>
</div>
<div class="edit-data edit-data__text-area" *ngIf="dataType == 'textarea'" >
    <div *ngIf="!loading" [@fadeIn]>
      <mat-label style="font-weight: 800;">{{placeholderText}}</mat-label>
      <textarea [id]="inputId" class="edit-data-textarea" *ngIf="canEdit" [(ngModel)]="value" (focus)="onFocus()" (focusout)="onFocusOut()"  [class.vert-resize-only]="vertResizeOnly" [placeholder]="placeholderText"></textarea>
      <span *ngIf="!canEdit">{{value}}</span>
      <div class="save-button" (click)="saveChange()" *ngIf="showSaveButton" [class.save-button__unsaved]="unsavedData" [class.saving]="saving" matTooltip="Save Changes">
          <i class="material-icons save-button__icon">check</i>
      </div>
      <div class="cancel-button" (click)="cancel()" *ngIf="showCancelButton" matTooltip="Cancel">
          <i class="material-icons cancel-button__icon">close</i>
      </div>
    </div>
    <div class="ph-item" *ngIf="loading">
      <div class="ph-row" style="height: 100px;">
        <div class="ph-col-12 big"></div>
      </div>
    </div>
</div>
<div class="edit-data edit-data__text" *ngIf="dataType == 'number'">
  <div *ngIf="!loading" [@fadeIn]>
    <input #numberInput [id]="inputId" *ngIf="canEdit" type="number" [(ngModel)]="value" (focus)="onFocus()" (focusout)="onFocusOut()" />
    <span *ngIf="!canEdit">{{value}}</span>
    <div class="save-button" (click)="saveChange()" *ngIf="showSaveButton" [class.save-button__unsaved]="unsavedData" [class.saving]="saving" matTooltip="Save Changes">
      <i class="material-icons save-button__icon">check</i>
    </div>
    <div class="cancel-button" (click)="cancel()" *ngIf="showCancelButton" matTooltip="Cancel">
      <i class="material-icons cancel-button__icon">close</i>
    </div>
  </div>
  <div class="ph-item" *ngIf="loading">
    <div class="ph-row">
      <div class="ph-col-12 big"></div>
    </div>
  </div>
</div>
